import React from 'react';
import DesignPage from '../components/DesignPage';

const Home = () => <DesignPage page="index" />;

export default Home;
